function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M294 378l56-56 142.027 116.204a14 14 0 0 1 1.034 20.735l-62.122 62.122a14.001 14.001 0 0 1-20.735-1.034L294 378zm-.589-167.411C284.832 193.57 280 174.345 280 154c0-69.541 56.459-126 126-126 35.996 0 68.486 15.127 91.456 39.365L364 103.124l30.746 114.746 134.142-35.943C516.169 238.048 465.945 280 406 280c-20.345 0-39.57-4.832-56.589-13.411L103.799 512.201c-10.935 10.935-28.663 10.935-39.598 0l-16.402-16.402c-10.935-10.935-10.935-28.663 0-39.598l245.612-245.612zM84 168L28 84l28-28 84 56v28l84 84-28 28-84-84H84z"
});

var SvgIconSettings = function SvgIconSettings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 560 560",
    "aria-hidden": "true",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_settings.472580a4.svg";
export { ForwardRef as ReactComponent };